import { project2BaseUrl } from './remoteClient';

/**
 * Trigger PDL data ingestion job
 * @param {string} token - Authorization token
 * @param {number} maxFiles - Maximum number of files to process (default: 1)
 * @returns {Promise} - Response with jobId and status
 */
export async function triggerPdlIngestion(token, maxFiles = 1) {
    return await project2BaseUrl.post(`/admin/pdl/ingest?maxFiles=${maxFiles}`, null, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

/**
 * Get PDL ingestion job status
 * @param {string} token - Authorization token
 * @param {number} jobId - Job ID to check status for
 * @returns {Promise} - Response with job status and stats
 */
export async function getPdlJobStatus(token, jobId) {
    return await project2BaseUrl.get(`/admin/pdl/status?jobId=${jobId}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

/**
 * Check if any PDL ingestion job is currently running
 * @param {string} token - Authorization token
 * @returns {Promise} - Response with running status and jobId if active
 */
export async function checkRunningPdlJob(token) {
    return await project2BaseUrl.get('/admin/pdl/running', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

/**
 * Get the last 3 PDL ingestion runs
 * @param {string} token - Authorization token
 * @returns {Promise} - Response with array of recent job runs
 */
export async function getRecentPdlRuns(token) {
    return await project2BaseUrl.get('/admin/pdl/recent', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}
